import templateGet from './get/template.html';
import controllerGet from './get';

const usersTeamsState = {
  url: '/teams',
  stateName: 'My Teams',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/users/:id/teams')
  },
  views: {
    'a@app': {
      template: templateGet,
      controller: controllerGet,
      controllerAs: 'usersTeamsCtrl'
    }
  }
};

export { usersTeamsState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/teams/index.js